/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ImageHelper, IMediaModel } from "@bms/common";
import { useTranslation } from "react-i18next";

import { ImageWithPlaceholder } from "components/ImageWithPlaceholder";
import resources from "resources/list";

import "./MatchTeamHeader.scss";

type IMatchTeamHeaderProps = {
  media?: IMediaModel;
  teamType?: "HomeTeam" | "AwayTeam";
};

export const MatchTeamHeader = ({ media, teamType }: IMatchTeamHeaderProps) => {
  const { t } = useTranslation();

  if (!media || !media.Match) {
    return null;
  }

  const team =
    teamType === "AwayTeam" ? media.Match.AwayTeam : media.Match.HomeTeam;

  if (!team) {
    return null;
  }

  const teamLogo = ImageHelper.getSquareImage(team?.Images);
  const teamTypeTitle =
    teamType === "AwayTeam"
      ? t("MATCH_DETAILS_AWAY_TEAM")
      : t("MATCH_DETAILS_HOME_TEAM");

  return (
    <div className="MatchTeamHeader">
      <div className="MatchTeamHeader__name">{team.Name}</div>
      <ImageWithPlaceholder
        imageData={teamLogo}
        imageContainerClassName="MatchTeamHeader__image-container"
        imageClassName="MatchTeamHeader__image"
        placeholderSrc={resources.squarePlaceholder}
        placeholderClassName="MatchTeamHeader__placeholder"
        disableAbsolutePosition
      />
      <div className="MatchTeamHeader__team-type">{teamTypeTitle}</div>
    </div>
  );
};
